import { useApiPaginated } from "@/hooks/useApiPaginated";
import type { Project } from "@/hooks/useProjects";
import { queryKeys } from "@/lib/queryKeys";

export function useProjectsPaginated(page: number, pageSize: number) {
  const { data, total, loading, error, refetch } = useApiPaginated<Project>(
    queryKeys.projects.paginated({ page, pageSize }),
    "/api/v2/projects",
    page,
    pageSize,
    undefined,
    "Failed to load projects",
  );
  return { projects: data, total, loading, error, refetch };
}
